import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import React, { useMemo } from 'react';
import { useFetchData } from 'hooks/useFetchData';
import { getWordingCategories } from 'backend/adminSettings';
import { IGetWordingsCategoriesInfo } from 'types';
import { ISelectOption } from 'components/Select/types';
import { useTranslation } from 'react-i18next';

interface ICategorySelect {
	setIDCategory: (value: string | null) => void;
}

const CategorySelect: React.FC<ICategorySelect> = ({ setIDCategory }) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetWordingsCategoriesInfo, null>(
		getWordingCategories,
	);
	const { t } = useTranslation('localizationSettings');
	const { t: tError } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: tError('selectCategory') }], [t]);

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		return (
			response?.data.groups.map((el) => ({
				id: el.id,
				name: t(el.name),
			})) || []
		);
	}, [t, response]);

	return (
		<FormSelect
			testId="CategorySelect"
			name="IDSelectedCategory"
			label="wordingCategoryLabel"
			options={mappedOptions}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			disabled={loading}
			onChange={setIDCategory}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(CategorySelect);
